class BookingPaymentMethodDisagioSessionField extends AbstractSessionFields
{
    user_id;
    banqu_account_id;

    constructor(user_id, banqu_account_id) {
        super(AbstractSessionFields.BOOKING_PAYMENT_METHOD_DISAGIO_KEY);
        this.user_id = user_id;
        this.banqu_account_id = banqu_account_id;
    }


    putInSession($value)
    {
        let booking_id = $('#barzahlen_booking_id').val();

        let minified_booking = $('[name="minified_booking"]').val();

        $.ajax({
                type: "POST",
                url:laroute.route('session_fields.put_in_session') ,
                dataType: "json",
                data: {user_id: this.user_id, banqu_account_id: this.banqu_account_id, key: this.key, value: 1},
                success: function (data) {
                    if(ExceptionsHelper.interface.validateResult(data))
                    {
                        $.ajax({
                                type: "POST",
                                url: laroute.route('ticketavis_booking.get_payments_view', {booking_id}),
                                dataType: "json",
                                data: {minified_booking},
                                success: function (data) {


                                    $('#payments_holder').empty().append(data.view);



                                    $('.tos_checkbox').prop('checked', true).trigger('change');
                                    openSinglePaymentPanel();

                                    scrollToSelector($('.payment-panel:eq(0)'));

                                    clickOnMaxReservationTimeSetter();
                                },
                                error: function (textStatus, errorThrown) {
                                    console.log(errorThrown.responseText);
                                }

                        });
                    }
                },
                error: function (textStatus, errorThrown) {
                    console.log(errorThrown.responseText);
                }

        });

       /* makeRequest(
            "POST",
            laroute.route('session_fields.put_in_session'),
            {user_id: this.user_id, banqu_account_id: this.banqu_account_id, key: this.key, value: 1}
        ).then( function (data){



        });*/
    }

    removeFromSession()
    {
        let booking_id = $('#barzahlen_booking_id').val();
        let minified_booking = $('[name="minified_booking"]').val();
        $.ajax({
                type: "POST",
                url: laroute.route('session_fields.remove_from_session'),
                dataType: "json",
                data: {user_id: this.user_id, banqu_account_id: this.banqu_account_id, key: this.key},
                success: function (data) {
                    if(ExceptionsHelper.interface.validateResult(data))
                    {
                        $.ajax({
                            type: "POST",
                            url: laroute.route('ticketavis_booking.get_payments_view', {booking_id}),
                            dataType: "json",
                            data: {minified_booking},
                            success: function (data) {
                                $('#payments_holder').empty().append(data.view);
                                $('.tos_checkbox').prop('checked', true).trigger('change');
                                openSinglePaymentPanel();

                                clickOnMaxReservationTimeSetter();
                            },
                            error: function (textStatus, errorThrown) {
                                console.log(errorThrown.responseText);
                            }

                        });
                    }
                },
                error: function (textStatus, errorThrown) {
                    console.log(errorThrown.responseText);
                }

        });

       /* makeRequest(
            "POST",
            laroute.route('session_fields.remove_from_session'),
            {user_id: this.user_id, banqu_account_id: this.banqu_account_id, key: this.key}
        ).then(function (data){



        });*/
    }
}